import {
  getValue,
  hasKey,
  isArray,
  isObject,
  isNull,
  isAtom,
  isFunction,
  isUndefined,
  isFalsy,
  isNullArray,
  isObjectOrArray,
} from '../helper/index.js';
import {
  JsonPath
} from '../json_path.js';

const JsonNode = function(json, jsonpath) {
  this.json = json;
  this.jsonpath = jsonpath;

  if (!this.jsonpath) {
    this.jsonpath = new JsonPath([]);
  }
};

JsonNode.prototype.next = function(key = '') {
  const nextJson = getValue(this.json, key);
  const nextJsonpath = this.jsonpath.next(key);

  return new JsonNode(nextJson, nextJsonpath);
};

JsonNode.prototype.getJson = function(key = '') {
  return getValue(this.json, key);
};

JsonNode.prototype.getJsonPath = function() {
  return this.jsonpath;
};

JsonNode.prototype.has = function(key) {
  return hasKey(this.json, key);
};

JsonNode.prototype.forEach = function(key, handler, {
  stopValue
} = {}) {
  const v = this.getJson(key);
  const n = this.next(key);

  if (isArray(v)) {
    for (let i = 0; i < v.length; i++) {
      const r = handler(n.next(i), i);
      if (stopValue !== undefined && stopValue === r) {
        break;
      }
    }
    return;
  }

  if (isObject(v)) {
    for (let key in v) {
      const r = handler(n.next(key), key);
      if (stopValue !== undefined && stopValue === r) {
        break;
      }
    }
    return;
  }
};

JsonNode.prototype.isNull = function(key) {
  return isNull(this.next(key).getJson());
};

JsonNode.prototype.isNullArray = function(key) {
  return isNullArray(this.next(key).getJson());
};

JsonNode.prototype.isArray = function(key) {
  return isArray(this.next(key).getJson());
};

JsonNode.prototype.isObject = function(key) {
  return isObject(this.next(key).getJson());
};

JsonNode.prototype.isObjectOrArray = function(key) {
  return isObjectOrArray(this.next(key).getJson());
};

JsonNode.prototype.isAtom = function(key) {
  return isAtom(this.next(key).getJson());
};

JsonNode.prototype.isFunction = function(key) {
  return isFunction(this.next(key).getJson());
};

JsonNode.prototype.isUndefined = function(key) {
  return isUndefined(this.next(key).getJson());
};

JsonNode.prototype.isFalsy = function(key) {
  return isFalsy(this.next(key).getJson());
};

export {
  JsonNode,
};
